import type { RecruitData, SurveyData } from "~/types";
import {
  jobList,
  contractorList,
  areaList,
  genderList,
} from "~/constants/recruit";

const initialRecruitData: RecruitData = {
  form_type: "newgrad",
  recruit_cd: 0,
  job: 0,
  area: [],
  fullname: "",
  furigana: "",
  gender: 1,
  post: "",
  address: "",
  tel: "",
  mail: "",
  message: "",
  // 新卒
  graduate: "",
  school: "",
  // 中途
  age: "",
  career: "",
  term: "",
  duties: "",
  start: "",
  // 職方
  work: [],
  business_name: "",
};

const _useRecruitData = () =>
  useState<RecruitData>("reqruitData", () => ({ ...initialRecruitData }));

const _useAgreement = () => useState<boolean>("isAgree", () => false);

export default function () {
  // 採用データ
  const recruitData = _useRecruitData();

  // 同意フラグ
  const isAgree = _useAgreement();

  //選択済み採用データ
  const selectedRecruit = computed(() => {
    // 新卒・中途　希望職種
    const job = jobList.find((item) => item.id === recruitData.value.job);

    // 職人　対応可能職種
    const work = recruitData.value.work.map((id) => {
      return contractorList.find((item) => item.id === id);
    });

    // 新卒・中途　希望エリア
    const area = recruitData.value.area.map((id) => {
      return areaList.find((item) => item.id === id);
    });

    // 新卒・中途　性別
    const gender = genderList.find(
      (item) => item.id === recruitData.value.gender,
    );

    return {
      ...recruitData.value,
      ...{ job, work, area, gender },
    };
  });

  // サーバーへ送信する処理
  async function postData() {
    const data = await $fetch("/api/form/recruit", {
      method: "POST",
      body: {
        recruit: selectedRecruit.value,
      },
    });
    if (data.status == "ok") {
      // 送信処理成功後　データーリセット
      resetData();
      return true;
    }
    throw new Error();
  }

  function resetData() {
    recruitData.value = { ...initialRecruitData };
    isAgree.value = false;
  }

  return {
    postData,
    resetData,

    recruitData,
    isAgree,

    selectedRecruit,
  };
}
